import { ApiHelper } from './apiHelper';

export class ContentApi {
    getAlloyText(successCallback = null, failureCallback = null) {
        const dataUrl = '/api/content/getalloytext?key=alloyConfirmationText';

        new ApiHelper().getData(dataUrl, successCallback, failureCallback);
    }

    getCosmeticText(successCallback = null, failureCallback = null) {
        const dataUrl =
            '/api/content/getcosmetictext?key=cosmeticConfirmationText';

        new ApiHelper().getData(dataUrl, successCallback, failureCallback);
    }

    getImage(successCallback = null, failureCallback = null) {
        const dataUrl = '/api/content/getImages';

        new ApiHelper().getData(dataUrl, successCallback, failureCallback);
    }
}
